export const pathToMenu = (path, menu ) => {
  for( let item of menu ) {
    if(item.link && item.link.endsWith(path)) return item
    if(item.submenus) {
      const match = pathToMenu(path, item.submenus)
      if(match) return match
    }
  }
  return null
}


// WEBPACK FOOTER //
// ../../src/Layout/pathToMenu.js